/* eslint-disable import/no-unresolved */
// import regex from "src/helpers/regex";
import { handelIndianCurrencyChange, onChangeIndianCurrency } from "src/helpers/FormDetails";
import CovidDetailsTogglebutton from "src/shared/CovidDetailsToggleButton";
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
}

function SelfEmployeedDetails({ formik }: Props) {
  // function handleChange(evt: any, formikk: any) {
  //   const { value, name } = evt.target;
  //   formikk.setFieldValue(name, value.replace(/,/g, ""));
  // }

  // function onChangeBudget(value: number) {
  //   const newValue = value.toString().replace(/,/g, "");
  //   const annualIncomeValue = newValue.replace(regex.indianCurrency, ",");
  //   return annualIncomeValue;
  // }
  return (
    <div>
      <div className="flex justify-between">
        <p className="text-daintree font-montserrat text-sm font-medium mb-6">
          If you are self-employed then,what is your Gross Turnover and annual income (Net Profit)
          from business abroad
        </p>
        <CovidDetailsTogglebutton
          isEnabled
          toggleState={formik.values.selfEmployed?.isSelfEmployed}
          fieldObj="selfEmployed"
          fieldName="isSelfEmployed"
          setFieldValue={formik.setFieldValue}
        />
      </div>
      {formik.values.selfEmployed.isSelfEmployed && (
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-222/1000 mb-6 md:mb-0 mr-8.75">
            <CustomTextField
              requiredStar
              label="Gross Turnover"
              className=""
              // onChange={handleChange("selfEmployed.grossTurnover")}
              onChange={(event) => handelIndianCurrencyChange(event, formik)}
              handleBlur={formik.handleBlur}
              value={onChangeIndianCurrency(formik.values.selfEmployed?.grossTurnover)}
              name="selfEmployed.grossTurnover"
              error={formik.errors.selfEmployed?.grossTurnover}
              touched={formik.touched.selfEmployed?.grossTurnover}
            />
          </div>
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar
              label="Annual Income"
              className=""
              // onChange={handleChange("selfEmployed.annualIncome")}
              onChange={(event) => handelIndianCurrencyChange(event, formik)}
              handleBlur={formik.handleBlur}
              value={onChangeIndianCurrency(formik.values.selfEmployed?.annualIncome)}
              name="selfEmployed.annualIncome"
              error={formik.errors.selfEmployed?.annualIncome}
              touched={formik.touched.selfEmployed?.annualIncome}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default SelfEmployeedDetails;
